<template lang="es">
  <v-dialog v-model="dialog" persistent max-width="400" transition="dialog-transition">
    <v-card class="text-center">
      <v-toolbar color="red" dark>
        <v-card-title class="text-h5">{{ titulo }}</v-card-title>
      </v-toolbar>
      <v-card-text :style="'font-size:120%'" class="mt-6">
        {{ mensaje }}
        <v-text-field
          v-model="pin"
          label="Contraseña"
          type="password"
          inputmode="numeric"
          pattern="[0-9]*"
          :error-messages="error ? ['Contraseña incorrecta'] : []"
          autofocus
          @keyup.enter="aceptar"
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="black" text @click="cancelar">
          Cancelar
        </v-btn>
        <v-btn color="red" text @click="aceptar">
          Aceptar
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions } from "vuex";

export default {
  props: {
    activar: Boolean,
    titulo: { type: String, default: "Confirmación requerida" },
    mensaje: { type: String, default: "Introduce la contraseña para continuar" },
    clave: { type: String, default: "clave_parada" },
  },
  data() {
    return {
      dialog: false,
      pin: "",
      error: false,
      claveEsperada: "0",
    };
  },
  watch: {
    activar() {
      if (this.activar) {
        this.pin = "";
        this.error = false;
        this.cargarClave();
        this.dialog = true;
      }
    },
  },
  methods: {
    ...mapActions("api", ["getAjuste"]),
    async cargarClave() {
      try {
        const res = await this.getAjuste(this.clave);
        this.claveEsperada = (res.data && res.data.valor != null) ? res.data.valor : "0";
      } catch (e) {
        this.claveEsperada = "0";
      }
    },
    aceptar() {
      if (this.pin === this.claveEsperada) {
        this.error = false;
        this.dialog = false;
        this.$emit("confirmado");
      } else {
        this.error = true;
      }
    },
    cancelar() {
      this.dialog = false;
      this.pin = "";
      this.error = false;
      this.$emit("cancelar");
    },
  },
};
</script>
<style lang="">
</style>
